import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SEOHead } from "@/components/seo/SEOHead";

export default function Termos() {
  return (
    <>
      <SEOHead title="Termos de Uso | Publee" description="Termos de uso da plataforma Publee." />
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-12 max-w-3xl">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <Button asChild variant="ghost" size="sm" className="mb-8">
              <Link to="/"><ArrowLeft className="w-4 h-4 mr-2" />Voltar</Link>
            </Button>

            <h1 className="text-4xl font-bold mb-8">Termos de Uso</h1>
            <div className="prose prose-invert max-w-none space-y-6 text-muted-foreground">
              <p><strong className="text-foreground">Última atualização:</strong> Fevereiro de 2026</p>

              <h2 className="text-xl font-semibold text-foreground">1. Aceitação dos Termos</h2>
              <p>Ao acessar e usar o Publee, você concorda com estes Termos de Uso. Se não concordar, não use a plataforma.</p>

              <h2 className="text-xl font-semibold text-foreground">2. Descrição do Serviço</h2>
              <p>O Publee é uma plataforma de criação de conteúdo UGC (User Generated Content) com inteligência artificial. Geramos imagens e vídeos publicitários a partir de descrições de produtos fornecidas pelo usuário.</p>

              <h2 className="text-xl font-semibold text-foreground">3. Uso da Plataforma</h2>
              <p>Você se compromete a: usar a plataforma apenas para fins legais; não enviar conteúdo ofensivo, ilegal ou que viole direitos de terceiros; manter suas credenciais de acesso seguras.</p>

              <h2 className="text-xl font-semibold text-foreground">4. Créditos e Pagamentos</h2>
              <p>O uso da plataforma é baseado em créditos. Cada criação consome créditos conforme o plano contratado. Créditos não utilizados podem expirar conforme as regras do plano.</p>

              <h2 className="text-xl font-semibold text-foreground">5. Propriedade Intelectual</h2>
              <p>O conteúdo gerado pela plataforma é de uso do usuário. A tecnologia, marca e código-fonte do Publee permanecem propriedade exclusiva da empresa.</p>

              <h2 className="text-xl font-semibold text-foreground">6. Limitação de Responsabilidade</h2>
              <p>O Publee não se responsabiliza por danos indiretos decorrentes do uso da plataforma. O serviço é fornecido "como está".</p>

              <h2 className="text-xl font-semibold text-foreground">7. Contato</h2>
              <p>Dúvidas? Entre em contato: <a href="mailto:suporte@publee.art" className="text-primary hover:underline">suporte@publee.art</a></p>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
}
